import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Packages from "./index";

const PackagesPage = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Packages />
    </DashboardLayout>
  );
};

export default PackagesPage;
